import { useState } from "react";
import {
  calcularDistribuicaoPorAno,
  formatarMoedaBRL,
} from "../utils/calcularTotaisPorAno.util";
import { calcularTotaisDashboard } from "../utils/agregarPorConta.util";
import styles from "../detalhe.styles.module.css";

/** Legenda do card — mostra no máximo 3 linhas; acima disso, uma seta expande a lista
 * completa (mesmo padrão adotado no dashboard do eSocial). */
function YearLegendColapsavel({ itens, label }) {
  const [expandido, setExpandido] = useState(false);
  const temMais = itens.length > 3;
  const visiveis = expandido ? itens : itens.slice(0, 3);
  return (
    <>
      <div className={styles.yearLegend}>
        {visiveis.map((item) => (
          <span key={item.ano}>
            <span className={styles.yearDot} style={{ background: item.cor }} />
            <strong>{item.ano}</strong> {formatarMoedaBRL(item.valor)}{" "}
            <span style={{ color: "#888" }}>
              ({item.pct.toLocaleString("pt-BR", { maximumFractionDigits: 1 })}%)
            </span>
          </span>
        ))}
      </div>
      {temMais && (
        <button
          type="button"
          className={styles.yearLegendToggle}
          onClick={() => setExpandido((v) => !v)}
          aria-expanded={expandido}
          aria-label={expandido ? `Recolher legenda de ${label}` : `Expandir legenda de ${label}`}
        >
          <span
            className={`${styles.yearLegendToggleIcon} ${
              expandido ? styles.yearLegendToggleIconOpen : ""
            }`}
            aria-hidden
          >
            ▼
          </span>
          {expandido ? "Ver menos" : `Ver mais (${itens.length - 3})`}
        </button>
      )}
    </>
  );
}

function CardMetrica({ label, campo, linhas }) {
  const totais = calcularTotaisDashboard(linhas);
  const valor = totais[campo] ?? 0;
  const porAno = calcularDistribuicaoPorAno(linhas, campo);

  return (
    <div className={styles.dashCard}>
      <div className={styles.dashLbl}>{label}</div>
      <div className={styles.dashSub}>Por ano (soma das competências no filtro)</div>
      <div className={styles.dashVal}>{formatarMoedaBRL(valor)}</div>
      {porAno.length > 0 && (
        <>
          <div
            className={styles.yearStack}
            role="img"
            aria-label={`Distribuição por ano — ${label}`}
          >
            {porAno.map((item) => (
              <span
                key={item.ano}
                title={`${item.ano}: ${formatarMoedaBRL(item.valor)} (${item.pct.toLocaleString("pt-BR", { maximumFractionDigits: 1 })}%)`}
                style={{
                  flex: `${Math.max(item.pct, 0.5)} 1 0%`,
                  minWidth: 4,
                  background: item.cor,
                }}
              />
            ))}
          </div>
          <YearLegendColapsavel itens={porAno} label={label} />
        </>
      )}
    </div>
  );
}

export default function DashboardCards({ linhas, totalLinhasOriginais = 0 }) {
  const lista = Array.isArray(linhas) ? linhas : [];
  const temOrigem = totalLinhasOriginais > 0;

  if (!temOrigem) {
    return (
      <div className={styles.dashGrid}>
        <div className={`${styles.dashCard} ${styles.dashCardAlerta}`}>
          <div className={styles.dashLbl}>Atenção</div>
          <p className={styles.dashAlertaTexto}>
            Nenhuma conta encontrada para esta apuração. Verifique se a sumarização foi concluída
            ou se existem dados materializados para o período.
          </p>
        </div>
      </div>
    );
  }

  if (lista.length === 0) {
    return (
      <div className={styles.dashGrid}>
        <div className={`${styles.dashCard} ${styles.dashCardVazio}`}>
          <div className={styles.dashLbl}>Sem totais</div>
          <p className={styles.dashAlertaTexto}>
            Nenhuma competência entrou no filtro atual. Amplie o intervalo de competência ou limpe
            os filtros para recalcular o dashboard.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.dashGrid}>
      <CardMetrica label="Total base Selic" campo="baseSelic" linhas={lista} />
      <CardMetrica label="Total PIS apurado" campo="pis" linhas={lista} />
      <CardMetrica label="Total COFINS apurado" campo="cofins" linhas={lista} />
    </div>
  );
}
